export default {
    'header.login': '登录',
    'header.register': '注册',
};